<script lang="ts">
    export let loading = true;
</script>

{#if loading}
    <div class="max-w-4xl mx-auto p-6 animate-pulse" data-testid="newsletter-detail-skeleton">

        <!-- Back button + Page Header -->
        <div class="flex items-center gap-3 mb-8">
            <div class="w-8 h-8 bg-gray-300 rounded"></div>
            <div class="h-6 w-40 bg-gray-300 rounded"></div>
        </div>

        <!-- Newsletter Title -->
        <div class="h-12 bg-gray-300 rounded mb-8 w-3/4"></div>

        <!-- Publication Date -->
        <div class="h-4 w-32 bg-gray-300 rounded mb-4"></div>
        
        <!-- CK Content-style HTML Block -->
        <div class="w-full h-96 bg-gray-300 rounded mb-6"></div>

    </div>
{/if}
